import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

const CODE = 'line-item/returning-renter-discount';

/**
 * Renders the 10% returning-renter loyalty discount in the customer
 * breakdown. Customer-only line — the provider view never sees it because
 * the line carries includeFor: ['customer'] on the server.
 */
const LineItemReturningRenterDiscountMaybe = props => {
  const { lineItems, intl, isProvider } = props;
  if (isProvider) return null;

  const discountLine = lineItems.find(
    item =>
      item.code === CODE &&
      !item.reversal &&
      (Array.isArray(item.includeFor) ? item.includeFor.includes('customer') : true)
  );
  if (!discountLine) return null;

  const formattedTotal = formatMoney(intl, discountLine.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.returningRenterDiscount" />
      </span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

LineItemReturningRenterDiscountMaybe.propTypes = {
  intl: intlShape,
};

LineItemReturningRenterDiscountMaybe.CODE = CODE;

export default LineItemReturningRenterDiscountMaybe;
